<div class="pp">

  <!-- The product first: the popup itself, cut out of its window, on the stage. -->
  <div class="pp-stage">
    <header class="pp-wrap pp-intro">
      <div class="pp-intro-main">
        <span class="pp-platform">
          <img src="./assets/third-parties/logo/chrome.webp" alt="">
          Chrome Extension
        </span>
        <h1 class="pp-name">
          <img src="./assets/product-lines/tools/chrome-color-picker.svg" alt="" class="pp-icon" width="72" height="72">
          <span>Color Picker</span>
        </h1>
        <p class="pp-pitch">Pick any color on your screen and read it in every color space, check its contrast and explore its harmonies, right from your toolbar</p>
        <ul class="pp-facts" aria-label="At a glance">
          <li *ngFor="let f of facts">{{ f }}</li>
        </ul>
      </div>

      <div class="pp-act">
        <div class="pp-cta">
          <a class="codigrate-button" [href]="storeUrl" target="_blank" rel="noopener" (click)="onInstall()"><p>Install from Chrome</p></a>
          <a class="codigrate-button cp-btn-neutral" routerLink="/tools/color"><p>Open the Color Explorer</p></a>
        </div>
      </div>
    </header>

    <div class="pp-wrap">
      <figure class="pp-shot" [class.pp-shot-panel]="hero.kind === 'panel'" [class.pp-shot-wide]="hero.kind === 'wide'">
        <img [src]="hero.src" [alt]="hero.alt" [width]="hero.width" [height]="hero.height" loading="eager" decoding="async">
      </figure>
    </div>
  </div>

  <div class="pp-wrap">

    <section class="pp-highlights" aria-label="Highlights">
      <div class="pp-highlight" *ngFor="let f of highlights">
        <h2>{{ f.title }}</h2>
        <p>{{ f.description }}</p>
      </div>
    </section>

    <section class="pp-section" *ngIf="screenshots.length">
      <h2 class="pp-section-title">Screenshots</h2>
      <div class="pp-gallery">
        <figure class="pp-figure" *ngFor="let s of screenshots">
          <button class="pp-shot" type="button" (click)="openLightbox( s )" [attr.aria-label]="'Enlarge ' + s.name">
            <img [src]="s.src" [alt]="s.alt" width="1600" height="1000" loading="lazy" decoding="async">
          </button>
          <figcaption>{{ s.name }}</figcaption>
        </figure>
      </div>
    </section>

    <section class="pp-section">
      <h2 class="pp-section-title">What Else It Does</h2>
      <ul class="pp-list">
        <li *ngFor="let f of more">
          <h3>{{ f.title }}</h3>
          <p>{{ f.description }}</p>
        </li>
      </ul>
    </section>

    <!-- Lightbox: the theme pages' (src/styles/page/tool-lightbox.scss). The picture over a
         frosted backdrop and one pill under it: previous, the picture's name, next, close.
         The arrow keys page through the pictures and Escape closes. -->
    <div class="cp-lightbox" *ngIf="lightbox" role="dialog" aria-modal="true" [attr.aria-label]="lightbox.name" (click)="closeLightbox()">
      <figure class="cp-lightbox-inner" (click)="$event.stopPropagation()">
        <img [src]="lightbox.large" [alt]="lightbox.alt">
      </figure>
      <ng-container *ngIf="shots.length > 1">
        <img class="td-lb-preload" [src]="shotAt( -1 ).large" alt="">
        <img class="td-lb-preload" [src]="shotAt( 1 ).large" alt="">
      </ng-container>
      <div class="cp-lightbox-caption-row" (click)="$event.stopPropagation()">
        <button class="cp-lb-seg cp-lb-nav" type="button" *ngIf="shots.length > 1" (click)="stepLightbox( -1, $event )" aria-label="Previous screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4.5 L7.5 12 L15 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <span class="cp-lb-seg td-lb-label">
          <span class="cp-lb-name">
            <span class="cp-lb-name-sizer" *ngFor="let s of shots" aria-hidden="true">{{ s.name }}</span>
            <span class="cp-lb-name-cur">{{ lightbox.name }}</span>
          </span>
        </span>
        <button class="cp-lb-seg cp-lb-nav" type="button" *ngIf="shots.length > 1" (click)="stepLightbox( 1, $event )" aria-label="Next screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4.5 L16.5 12 L9 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <button class="cp-lb-seg cp-lb-close" type="button" (click)="closeLightbox()" aria-label="Close">&times;</button>
      </div>
    </div>

    <section class="cp-closing">
      <h2 class="cp-closing-title">Grab Your First Color</h2>
      <p class="cp-closing-text">Add it to Chrome and the eyedropper is one click away on every tab</p>
      <a class="codigrate-button cp-closing-btn" [href]="storeUrl" target="_blank" rel="noopener" (click)="onInstall()"><p>Install from Chrome</p></a>
    </section>

  </div>

</div>
